export * from './core';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/core/index.js
// module id = 371
// module chunks = 3